module.exports = __webpack_public_path__ + "static/media/Horse And Groom.315f9291.jpg";